var _g, _defs;
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgColumnIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_22432_46545)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1.06468 12.9618V0.726391C1.06468 0.595141 0.940723 0.409203 0.802181 0.387328C0.492285 0.336287 0.364681 0.522224 0.350098 0.810245V13.1988C0.375618 13.5451 0.492285 13.6253 0.827702 13.6509H13.1907C13.4824 13.6509 13.6975 13.4686 13.6027 13.155C13.5881 13.1076 13.4496 12.9655 13.4095 12.9655H1.06468V12.9618ZM12.1662 2.07899C12.1407 2.3342 12.0204 2.70243 12.3631 2.79722C12.7058 2.89202 12.7678 2.65139 12.8152 2.41077C12.8626 2.17014 12.9683 1.54306 12.9866 1.21493C13.0048 0.886807 12.9428 0.78837 12.6438 0.737328C12.1918 0.828474 11.6704 0.795662 11.2256 0.87587C10.7808 0.956078 10.8136 1.09097 10.9084 1.35347C11.0032 1.61597 11.4699 1.49931 11.7287 1.54306L8.54229 4.70399L6.87614 2.62222C6.69385 2.45452 6.49697 2.49097 6.32926 2.65139L2.11833 6.86233C1.7902 7.21962 2.19854 7.66806 2.58499 7.38368L6.58083 3.39514L8.24697 5.46962C8.36364 5.57899 8.49854 5.62274 8.65166 5.55347L12.1662 2.08264V2.07899ZM13.1251 4.12795H11.2657V12.0321H13.1251V4.12795ZM6.94541 6.20608H5.08604V12.0321H6.94541V6.20608ZM10.0334 7.32899H8.17406V12.0321H10.0334V7.32899ZM3.85739 9.02431H1.96885V11.992L2.00895 12.0321H3.85374V9.02431H3.85739Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.0647 12.9606H13.4095C13.4496 12.9606 13.5881 13.1028 13.6027 13.1502C13.6975 13.4601 13.4861 13.6424 13.1907 13.646H0.831364C0.495947 13.6241 0.379281 13.5403 0.35376 13.1939V0.805394C0.368343 0.517373 0.492301 0.335081 0.805843 0.382477C1.11938 0.429873 1.06834 0.59029 1.06834 0.72154V12.957L1.0647 12.9606Z",
    fill: "#333333"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.125 4.12891H11.2656V12.0331H13.125V4.12891Z",
    fill: "#333333"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.94531 6.20703H5.08594V12.0331H6.94531V6.20703Z",
    fill: "#333333"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.0334 7.32812H8.17407V12.0312H10.0334V7.32812Z",
    fill: "#333333"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.85729 9.02344V12.0312H2.00885L1.96875 11.9911V9.02344H3.85729Z",
    fill: "#333333"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_22432_46545"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 14,
    height: 14,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgColumnIcon);
export default __webpack_public_path__ + "static/media/columnIcon.9c4f6f2a48ebc96798412b8d6fe0e954.svg";
export { ForwardRef as ReactComponent };